// extracted by css-extract-rspack-plugin
export default {"additionalSettingsSection":"PropertyDefinitionForm-module__additionalSettingsSection__HCwOy","propertyFormControl":"PropertyDefinitionForm-module__propertyFormControl__QfG_f"};